/* eslint-disable @typescript-eslint/no-explicit-any */
// we use any throughout as the debounced function can take any args
var debounce = function debounce(func) {
  var timeOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  // We have to use a compound type due to the fact that this util can be run
  // within a node or browser enviroment https://stackoverflow.com/a/56239226
  var timer;
  return function () {
    if (timer) clearTimeout(timer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    timer = setTimeout.apply(void 0, [func, timeOut].concat(args));
  };
};

export default debounce;